// extracted by mini-css-extract-plugin
module.exports = {"defaultUnitValue":"8px","smallBreakpoint":"600px","largeBreakpoint":"1200px","main":"main-module--main---XZw4"};